module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post-list"
  }, [_c('ui-floating-box', [_c('router-link', {
    attrs: {
      "to": {
        name: 'new-post'
      }
    }
  }, [_c('ui-button', {
    attrs: {
      "icon": "add",
      "type": "button",
      "primary": "",
      "fab": "",
      "big-icon": ""
    }
  })], 1)], 1), _vm._v(" "), _c('ui-grid', {
    attrs: {
      "name": "post",
      "fields": _vm.fields,
      "records": _vm.posts,
      "actions": _vm.actions,
      "converter": _vm.converter,
      "paging": _vm.postPaging
    },
    on: {
      "selectedsAction": _vm.removeSelecteds
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48d83dae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modules/Post/PostList.vue
// module id = 271
// module chunks = 2